import { Component, Input } from '@angular/core';
import { ReadMore, TextAlign } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-profile-summary-description',
  template: `
    <fl-text
      *ngIf="!isViewerProfileOwner; else selfView"
      class="Content"
      [maxLines]="15"
      [readMore]="ReadMore.LINK"
      [textAlign]="TextAlign.LEFT"
    >
      <ng-container *ngIf="isLoggedIn; else loggedOut">
        {{ description }}
      </ng-container>

      <ng-template #loggedOut>
        {{ description | stripUrl: '[login to view URL]':true }}
      </ng-template>
    </fl-text>

    <ng-template #selfView>
      <fl-text class="Content" [textAlign]="TextAlign.LEFT">
        {{ description }}
      </fl-text>
    </ng-template>
  `,
  styleUrls: ['./user-profile-summary-description.component.scss'],
})
export class UserProfileSummaryDescriptionComponent {
  TextAlign = TextAlign;
  ReadMore = ReadMore;

  @Input() description: string;
  @Input() isViewerProfileOwner: boolean;
  @Input() isLoggedIn: boolean;
}
